import type { SxProps, Theme } from '@mui/material'

interface ContainerArgs {
  hasToolbarWithBorder?: boolean
  showSearchFieldBorder?: boolean
}

export const tableMobileSearchStyles = {
  container: ({
    hasToolbarWithBorder,
    showSearchFieldBorder = true,
  }: ContainerArgs): SxProps<Theme> => ({
    borderTopRightRadius: hasToolbarWithBorder ? 0 : 0.5,
    borderTopLeftRadius: hasToolbarWithBorder ? 0 : 0.5,
    ...(!showSearchFieldBorder && {
      borderLeftWidth: 1,
      borderLeftStyle: 'solid',
      borderLeftColor: 'gray.12',
      borderTopWidth: 1,
      borderTopStyle: 'solid',
      borderTopColor: 'gray.12',
      borderRightWidth: 1,
      borderRightStyle: 'solid',
      borderRightColor: 'gray.12',
    }),
  }),
}
